import type {
  FilteredExploreAirlineState,
  FilteredExploreAirlineById,
  FilteredExploreAirline,
} from '@web-platform/shared-universal-types/src/redux/banana/state/combinedResults/entitiesSearchResults/adverts/filteredExploreAirline';

/**
 * Get the FilteredExploreAirline state
 *
 * @param {FilteredExploreAirlineState} state - The FilteredExploreAirline state slice
 * @returns {FilteredExploreAirlineState} The complete state object
 */
export const getFilteredExploreAirlineState = (
  state: FilteredExploreAirlineState,
): FilteredExploreAirlineState => state;

/**
 * Get all FilteredExploreAirline ads by ID
 *
 * @param {FilteredExploreAirlineState} state - The FilteredExploreAirline state slice
 * @returns {FilteredExploreAirlineById} Map of ad IDs to FilteredExploreAirline objects
 */
export const getFilteredExploreAirlineById = (
  state: FilteredExploreAirlineState,
): FilteredExploreAirlineById => state.byId;

/**
 * Get the first available FilteredExploreAirline ad
 *
 * @param {FilteredExploreAirlineState} state - The FilteredExploreAirline state slice
 * @returns {FilteredExploreAirline | null} The first available ad, or null if none exist
 */
export const getFirstFilteredExploreAirline = (
  state: FilteredExploreAirlineState,
): FilteredExploreAirline | null => {
  const byId = getFilteredExploreAirlineById(state);
  const ids = Object.keys(byId);
  return ids.length > 0 ? byId[ids[0]] : null;
};
